/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

// TODO: Remove dependency on Web core.
import StringsStore from "sh-strings/store";

/**
 * Gets a translation string from the strings store.
 * @param parentKey Name of the parent key to ge the strings dictionary from.
 * @param key Name of the key to get the string from.
 * @param placeholders The optional list of placeholders values to replace in the translation string. The placeholders are replaced based on given values indexed. Example: {0} is replaced with placeholders[0].
 * @returns The translation string from the strings store.
 */
export const getStrings = (parentKey: string, key: string, placeholders?: string[]): string | undefined => {
    const parent = StringsStore().registeredStringModules.get(parentKey);
    let translation = parent?.strings.get(key);

    if (translation && placeholders) {
        translation = translation.replace(/{(\d+)}/g, (match, index) => {
            return typeof placeholders[index] != "undefined" ? placeholders[index] : match;
        });
    }

    return translation;
};
